import { render, staticRenderFns } from "./ClinicOnLineTableCmp2.vue?vue&type=template&id=2b6b42a1&"
import script from "./ClinicOnLineTableCmp2.vue?vue&type=script&lang=js&"
export * from "./ClinicOnLineTableCmp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports